import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';

import shape from './shape';
import typography from './typography';
import breakpoints from './breakpoints';
import transitions from './transitions';
import componentsOverride from './overrides';

import { paletteFactory } from './palette.factory';
import { shadowsFactory } from './shadows.factory';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
    children: PropTypes.node,
};

export default function ThemeConfig({ children }) {
    const [darkMode, setDarkMode] = useState(false);
    const { theme: reduxTheme } = useSelector(state => state.user);

    useEffect(() => {
        setDarkMode(reduxTheme !== 'white');
    }, [reduxTheme]);

    const theme = useMemo(() => {
        const mode = darkMode ? 'dark' : 'light';

        const { shadows, customShadows } = shadowsFactory(mode);

        const baseTheme = createTheme({
            palette: paletteFactory(mode),
            shadows,
            customShadows,
            shape,
            typography,
            breakpoints,
            transitions,
        });

        return createTheme(baseTheme, {
            components: componentsOverride(baseTheme),
        });
    }, [darkMode]);

    return (
        <StyledEngineProvider injectFirst>
            <StylesThemeProvider theme={theme}>
                <MuiThemeProvider theme={theme}>
                    <StyledThemeProvider theme={theme}>
                        <CssBaseline />
                        {children}
                    </StyledThemeProvider>
                </MuiThemeProvider>
            </StylesThemeProvider>
        </StyledEngineProvider>
    );
}
